export const generalTabRoute = 'applet-design-version-general';
export const varsTabRoute = 'applet-design-version-vars';
export const screensTabRoute = 'applet-design-version-screens';
export const jsonTabRoute = 'applet-design-version-json';
export const scriptsTabRoute = 'applet-design-version-scripts';
export const flowsTabRoute = 'applet-design-version-flows';
export const eventsTabRoute = 'applet-design-version-events';
export const appletVariablesTabRoute = 'applet-design-version-applet-variables';

export type TabRoute = typeof generalTabRoute | typeof varsTabRoute | typeof screensTabRoute | typeof jsonTabRoute | typeof scriptsTabRoute | typeof flowsTabRoute | typeof appletVariablesTabRoute;
